import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useAcquirerLogin } from '@services/acquirer/session/create';
import { AcquirerUser, AuthRespSuccess } from '@root/globalTypes';

export const useAcquirerLoginForm = ({
  successHandler,
}: {
  successHandler: (data: AuthRespSuccess<AcquirerUser>) => Promise<void>;
}) => {
  const { t } = useTranslation('app');
  const schema = z.object({
    acquirer: z
      .string()
      .trim()
      .min(1, {
        message: t('form.acquirerName.required'),
      }),
    email: z
      .string()
      .trim()
      .email({
        message: t('form.email.required'),
      }),
    password: z
      .string()
      .trim()
      .min(1, {
        message: t('form.password.required'),
      }),
  });

  const defaultValues = {
    acquirer: '',
    email: '',
    password: '',
  };

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: defaultValues,
  });

  const { mutate, isPending, error } = useAcquirerLogin({ successHandler });

  const onSubmit = async (values: z.infer<typeof schema>) => {
    mutate(values);
  };

  return {
    form,
    onSubmit,
    isPending,
    error,
  };
};
